import { WaitingParty } from '../models';

export function getWaitingTemplate(): WaitingParty[] {
  return [
    {
      sizeGroup: 0,
      name: '1-2',
      count: 0,
      wait: 0,
    },
    {
      sizeGroup: 1,
      name: '3-4',
      count: 0,
      wait: 0,
    },
    {
      sizeGroup: 2,
      name: '5-6',
      count: 0,
      wait: 0,
    },
    {
      sizeGroup: 3,
      name: '7-8',
      count: 0,
      wait: 0,
    },
    {
      sizeGroup: 4,
      name: '9+',
      count: 0,
      wait: 0,
    },
  ];
}
